let recipient_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'my-recipients', name: 'recipients.my', component: () => import('./pages/MyRecipients.vue') },
      { path: 'recipients/:id/edit', name: 'recipients.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default recipient_routes;
